import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const links = [
    { label: "Блог",               path: "/news"    },
    { label: "Об игре",            path: "/about"   },
    { label: "Конфиденциальность", path: "/privacy" },
    { label: "Условия",            path: "/terms"   },
    { label: "Оферта",             path: "/offer"   },
  ];

  return (
    <footer style={{
      borderTop: "1px solid #1a0535",
      padding: "1.5rem",
      textAlign: "center",
      background: "transparent",
      position: "relative",
      zIndex: 1,
    }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem 1.5rem", justifyContent: "center", marginBottom: "0.75rem" }}>
        {links.map(l => (
          <button key={l.path} onClick={() => navigate(l.path)} style={{
            background: "none", border: "none", cursor: "pointer",
            fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem",
            color: "#444", textDecoration: "none",
            transition: "color 0.15s",
          }}
            onMouseEnter={e => e.currentTarget.style.color = "#9b5de5"}
            onMouseLeave={e => e.currentTarget.style.color = "#444"}
          >{l.label}</button>
        ))}
      </div>
      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.75rem", color: "#333" }}>
        © 2026 NeonParty — все права защищены
      </p>
    </footer>
  );
}